module.exports = __webpack_public_path__ + "img/gq12.926d9566.png";